import "core-js/modules/es6.string.starts-with";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intlMixin } from '@/i18n/intl-i18n';
import { getSupportedLanguages } from '@/api/international';
export default {
  name: 'IntlHeader',
  mixins: [intlMixin],
  data: function data() {
    return {
      drawerOpen: false,
      langPopupOpen: false
    };
  },
  mounted: function mounted() {
    this.loadLanguages();
  },
  methods: {
    loadLanguages: function () {
      var _loadLanguages = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return getSupportedLanguages();
            case 1:
              res = _context.sent;
              if (res.data.code === 200) this.$setIntlLangOptions(res.data.data);
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('loadLanguages', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadLanguages() {
        return _loadLanguages.apply(this, arguments);
      }
      return loadLanguages;
    }(),
    onLangSelect: function onLangSelect(lang) {
      this.$setIntlLang(lang);
      this.langPopupOpen = false;
    },
    isNavActive: function isNavActive(nav) {
      var path = this.$route.path;
      if (nav === 'home') return path === '/international/home';
      if (nav === 'news') return path.startsWith('/international/news') || path.startsWith('/international/newsDetail');
      if (nav === 'courses') return path.startsWith('/international/courses') || path.startsWith('/international/courseDetail');
      if (nav === 'about') return path === '/international/about';
      return false;
    }
  }
};